import { useEffect } from "react";

export default function useClickOutside(refs, onClose) {
  useEffect(() => {
    function handleClickOutside(event) {
      // Always treat refs as array
      const refArray = Array.isArray(refs) ? refs : [refs];

      const isInside = refArray.some((ref) => ref.current && ref.current.contains(event.target));
      if (!isInside) {
        onClose();
      }
    }

    function handleKeyDown(event) {
      if (event.key === "Escape") {
        onClose();
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [refs, onClose]);
}
